import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useTagVocabulary } from '../queries';

interface TagFilterSelectProps {
  /** Selected tag id as a string, or 'all' for no filter. */
  value: string;
  onChange: (value: string) => void;
}

/** List-toolbar dropdown to filter by a single org tag. Backed by the shared
 *  tag vocabulary; pair the chosen id with the `?tag=` list param. */
export function TagFilterSelect({ value, onChange }: TagFilterSelectProps) {
  const { data } = useTagVocabulary();
  const tags = data ?? [];

  return (
    <Select value={value} onValueChange={onChange}>
      {/* Content-width (base w-fit) — sizes to the selected tag, no dead space. */}
      <SelectTrigger className="h-9 min-w-28" aria-label="Filter by tag">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All tags</SelectItem>
        {tags.map((t) => (
          <SelectItem key={t.id} value={String(t.id)}>
            {t.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
